import { useCommand } from '@akin-home/commands-react';
import { useCallback } from 'react';
import { UpdateFieldCommand } from '../commands/types';

type CallbackParam = (data: object) => void;

export const useUpdateFieldsCommand = (callback: CallbackParam) => {
  useCommand<UpdateFieldCommand>(
    'update_field',
    useCallback(
      (commands) => {
        callback(
          commands.reduce(
            (data, cmd) => ({ ...data, [cmd.data.field_name]: cmd.data.value }),
            {}
          )
        );
      },
      [callback]
    )
  );

  return callback;
};
